import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../components/modal/ModalCustom';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { MeetingTypeApi } from '../../../api/meeting-type/meeting-type.api';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { routeName } from '../../../routes/routeName';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { ThesisBookApi } from '../../../api/thesis-book/thesis-book.api';

const defaultState = {
    id_thesis_category: 0,
    thesis_category_name: undefined,
}
export default function EThesisLibrary() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");

    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "#",
        },
        {
            id: "leave_type_name",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อ"),
        },

        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ผู้จัดทำ"),
        },

        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ประเภท"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("หมวดหมู่"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_thesis_book, thesis_type_name, thesis_book_name, thesis_category_name, thesis_book_created, status, modifier_name, modified_date } =
            objData;

        const objRenderData = {
            key: id_thesis_book,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: thesis_book_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: thesis_book_created,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: thesis_category_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: thesis_type_name,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit
                            enableDelete
                            onViewClick={() => {
                                 navigate(routeName.cms.DetailEThesisLibrary.replace(':id', id_thesis_book) + '?mode=VIEW')
                            }}

                            onEditClick={() => {
                                navigate(routeName.cms.DetailEThesisLibrary.replace(':id', id_thesis_book))
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_thesis_book)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await ThesisBookApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit,]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }


    const handleDelete = async (id: any) => {
        await ThesisBookApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบวิทยานิพนธ์ เรียบร้อยแล้ว'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    return (
        <div>
            <ContentHeading
                title={t("ห้องสมุด E-Thesis")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา ชื่อหมวดหมู่วิทยานิพนธ์")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            navigate(routeName.cms.AddEThesisLibrary);

                        }}
                        mode="add"
                        buttonName={t("เพิ่มวิทยานิพนธ์")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>

        </div>
    )
}
